import React, { Component } from 'react';
import UserDocumentsTable from './UserDocumentsTable';
import UserDocumentsTableActions from './UserDocumentsTableActions';
import FileUpload from '@material-ui/icons/Search';
import { Button, UncontrolledTooltip, Row, Col } from 'reactstrap';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import UserDocumentsModalForm from './UserDocumentsModalForm';
import Spinner from 'react-bootstrap/Spinner';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';

const MedicalCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#4ce1b6',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

class UserDocuments extends Component {

  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      documentsFiltered: [],
      showDocument: false,
      tempURLDocument: null,
      openModal: false,
      isLoading: false
    }
  }

  componentDidMount = () => {
    this.listDocuments();
  }

  listDocuments = async () => {
    this.setState({ isLoading: true });
    if (this.props.idTeamInvestorMember != undefined && this.props.idTeamInvestorMember != null) //Si pertenece a un Estudio Clinico
    {
      await this.listDocumentsDoctorClinicalStudy();
    }
    else //Si son todos los Documentos
    {
      await this.listAllDocuments();
    }
  }

  listDocumentsDoctorClinicalStudy = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'estudio-entrenamiento/listar?id_usuario=' + this.props.id_usuario, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.setState({ documents: data,documentsFiltered:data, isLoading: false });
      })
      .catch((error) => {
        this.setState({ documents: [],documentsFiltered:[], isLoading: false });
        console.error('Error:', error);
      });
  }

  listAllDocuments = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'docs-usuario/listar?id_usuario=' + this.props.id_usuario, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.setState({ documents: data,documentsFiltered:data, isLoading: false });
      })
      .catch((error) => {
        this.setState({ documents: [],documentsFiltered:[], isLoading: false });
        console.error('Error:', error);
      });
  }

  clickUploadFile = () => {
    this.setState({ openModal: true });
  }

  onShowDocument = (urlDocument, fileName) => {
    let ext = fileName.slice((fileName.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();
    if (ext == 'pdf' || ext == 'png' || ext == 'jpg' || ext == 'jpeg' || ext == 'bmp') {
      this.visualizeDocument(urlDocument, fileName);
    }
    else {
      this.downloadDocument(urlDocument, fileName);
    }
  }

  downloadDocument = async (urlDocument, fileName) => {
    var a = document.createElement('a');
    a.href = urlDocument;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  visualizeDocument = async (urlDocument, fileName) => {
    await fetch(urlDocument, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    }).then(res => res.blob()).then(blob => {
      this.setState({ tempURLDocument: window.URL.createObjectURL(blob) }, () => {
        this.setState({ showDocument: true })
      });
    }).catch(err => {
      console.log(err);
    });
  }

  onCloseDocument = () => {
    this.setState({ showDocument: false, tempURLDocument: null });
  }

  handleChangeCheckboxFilterDocsStudy = (value,check) => {
    if(check == true)
    {
      this.setState({ documentsFiltered: this.state.documents.filter(doc => doc.id_entrenamiento != null && doc.id_entrenamiento != undefined) })
    }
    else
    {
      this.setState({ documentsFiltered: this.state.documents })
    }
  }

  render() {
    const TableDocuments = () => {
      return (<UserDocumentsTable
        reactTableData={this.state.documentsFiltered}
        ReactTableActions={UserDocumentsTableActions}
        onShowDocument={this.onShowDocument}
        Callback={() => { this.listDocuments() }}
        idTeamInvestorMember={this.props.idTeamInvestorMember != undefined && this.props.idTeamInvestorMember != null ? this.props.idTeamInvestorMember : null}
      />);
    }

    return (
      <>
        <Row>
          <Col md={6}>
            {
              this.props.idTeamInvestorMember != null ? <FormControlLabel
                value={"Mostrar solo los documentos que pertenecen al Estudio"}
                control={
                  <MedicalCheckbox
                    onChange={(event, check) => {
                      this.handleChangeCheckboxFilterDocsStudy(event.target.value, check)
                    }}
                    iconStyle={{ fill: 'green' }} />
                }
                label={"Mostrar solo los documentos que pertenecen al Estudio"}
                labelPlacement={"Mostrar solo los documentos que pertenecen al Estudio?"}
              /> : null
            }
          </Col>
          <Col md={6}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: 30 }}>
              {
                this.props.permissionUpload ? <><Button
                  style={{ marginRight: 10, marginTop: 10 }}
                  color="primary"
                  size="sm"
                  id="uploadBtn"
                  onClick={() => {
                    this.clickUploadFile();
                  }}
                >
                  <FontAwesomeIcon icon={faUpload} />
                </Button>
                  <UncontrolledTooltip placement="top" target="uploadBtn">
                    Subir Documento
                  </UncontrolledTooltip></> : null
              }
            </div>
          </Col>
        </Row>

        {
          this.state.isLoading == false ? <TableDocuments />
            :
            <div className="text-center">
              <Spinner animation="border" variant="success" />
            </div>
        }



        <UserDocumentsModalForm
          idUser={this.props.id_usuario}
          fileInformation={null}
          opened={this.state.openModal}
          close={() => { this.setState({ openModal: false }) }}
          Callback={() => { this.listDocuments() }}
        />

        {this.state.showDocument ?
          <Modal
            open={this.state.showDocument}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
            onClose={this.onCloseModal}
          >
            <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
              <IconButton style={{ float: 'right' }} onClick={() => {
                this.onCloseDocument();
              }}>
                <CloseIcon />
              </IconButton>
              <iframe id="pdfV" width="1000" height="700" src={this.state.tempURLDocument} >
              </iframe>
            </div>
          </Modal>

          : null}
      </>
    );
  }
}

export default UserDocuments;
